<template>
    <textarea
        :rows="row"
        :maxlength="maxlength"
        @input="$emit('update:modelValue', $event.target.value)"
        class="bg-gray-input focus:bg-gray-50 focus:border-teal-600 mt-1
        focus:ring-opacity-50 rounded-md block w-full shadow-sm">
        {{ modelValue }}
        </textarea>
</template>

<script>
    export default {
        props: ['modelValue'],
        emits: ['update:modelValue'],
        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>